import BarcodeScannerHandler from './BarcodeScannerHandler/BarcodeScannerHandler.vue'
import CounterControl from './CounterControl/CounterControl.vue'
import CrudCreateButton from './CrudCreateButton/CrudCreateButton.vue'
import DashboardMenu from './DashboardMenu/Dashboard.vue'
import RUTInput from './RUTInput/RUTInput.vue'
import SearchBox from './SearchBox/SearchBox.vue'
import SelectButtons from './SelectButtons/SelectButtons.vue'
import SimpleAuth from './SimpleAuth/AuthModal.vue'
import SnackbarModal from './SnackbarModal/SnackbarModal.vue'
import CrudForm from './CrudForm/CrudForm.vue'
import CrudDataTable from './CrudDataTable/CrudDataTable.vue'
import LoadingDialog from './LoadingDialog/LoadingDialog.vue'
import InputButton from './InputButton/InputButton.vue'
import BreadCrumb from './BreadCrumb/BreadCrumb.vue'
import { DELETE_ITEM } from './SnackbarModal/SnackbarActions'

import {
    getFetchDataFunction,
    generateQuery,
    generateFetchDataFunction,
} from './CrudDataTable/service/DataTableService'

const DTService = {
    getFetchDataFunction,
    generateFetchDataFunction,
    generateQuery,
}

//Product Search
import AlterAutoComplete from './AlterAutoComplete/AlterAutoComplete'

export {
    BarcodeScannerHandler, //
    CounterControl, //
    CrudCreateButton, //
    DashboardMenu, //
    RUTInput, //
    SearchBox,
    SelectButtons,
    SimpleAuth,
    SnackbarModal, //
    CrudForm, //
    CrudDataTable, //
    LoadingDialog,
    DELETE_ITEM,
    DTService,
    InputButton,
    BreadCrumb,
    AlterAutoComplete,
}